package gr.tech.meetinggenie.navigation

sealed class SitePage(val route: String) {
    data object Home     : SitePage(route = "/")
    data object Login    : SitePage(route = "/login")
    data object Meetings : SitePage(route = "/meetings")
    data object Meeting  : SitePage(route = "/meeting")  // /meeting/{id}
}
